(function () {
    'use strict';

    angular
        .module('cog.shared')
        .factory('MememtoService', MememtoServiceController);

    /* @ngInject */
    function MememtoServiceController(accountService, $q) {        
        var local = {
            lastBalanceTime: 0,     lastBalanceObj: null,
            lastBetTypeTime: 0,     lastBetTypeObj: null,
            lastScoreBoardTime: 0,  lastScoreBoardObj: null,
        };

        var service  = {
            getBalanceMememto: getBalanceMememto,
            getAllowedBetTypesMemento: getAllowedBetTypesMemento,
            getScoreboardMemento: getScoreboardMemento,
            clearAll: clearAll
        };
        return service;       

        function getAllowedBetTypesMemento() {
            var defer = $q.defer();
            if (local.lastBetTypeTime == 0 || local.lastBetTypeTime < new Date().getTime()) {
                getDataBasedonTime(
                    accountService.getAllowedBetTypes, 
                    function(data) {  
                        local.lastBetTypeObj = data;
                        local.lastBetTypeTime = new Date().getTime() + 60*1000; //60 segs
                        defer.resolve(local.lastBetTypeObj);
                    }, 
                    function() {                            
                        //local.lastBetTypeObj = null; <-- try to return old value
                        local.lastBetTypeTime = 0;
                        if (local.lastScoreBoardObj==null)
                            defer.reject();
                        else
                            defer.resolve(local.lastBetTypeObj);                        
                    }
                );
            }else defer.resolve(local.lastBetTypeObj);            
            return defer.promise;
        }

        function getBalanceMememto() {
            var defer = $q.defer();
            if (local.lastBalanceTime == 0 || local.lastBalanceTime < new Date().getTime()) {
                getDataBasedonTime(
                    accountService.getBalance,
                    function(data) {  
                        local.lastBalanceObj = data;
                        local.lastBalanceTime = new Date().getTime() + 5*1000; //60 segs
                        defer.resolve(local.lastBalanceObj);
                    }, 
                    function() {                            
                        local.lastBalanceObj = null; //<--null old just 
                        local.lastBalanceTime = 0;
                        defer.resolve(local.lastBalanceObj);
                    }
                );
            }else defer.resolve(local.lastBalanceObj);
            return defer.promise;
        }

        function getScoreboardMemento() {
            var defer = $q.defer();
            if (local.lastScoreBoardTime == 0 || local.lastScoreBoardTime < new Date().getTime()) {
                getDataBasedonTime(
                    accountService.getScoreboard,
                    function(data) {  
                        local.lastScoreBoardObj = data;
                        local.lastScoreBoardTime = new Date().getTime() + 60*1000; //60 segs
                        defer.resolve(local.lastScoreBoardObj);
                    }, 
                    function() {                            
                        //local.lastScoreBoardObj = null; //<--try to return old value
                        local.lastScoreBoardTime = 0;
                        if (local.lastScoreBoardObj==null)
                            defer.reject();
                        else
                            defer.resolve(local.lastScoreBoardObj);
                    }
                );
            }else defer.resolve(local.lastScoreBoardObj);
            return defer.promise;
        }

        function clearAll(){
            local.lastBalanceTime= 0;
            local.lastBetTypeTime= 0;
            local.lastScoreBoardTime=0;
        }

        function getDataBasedonTime(fnCall, fnSet, fnFail) {            
            fnCall()
            .success(function (response, status) {
                if (status == 200 && response!=null) 
                    fnSet(response);
                else 
                    fnFail();
            })
            .error(function (error) {
                fnFail();
            });            
        }  
    }
})();    